import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { Card, Button, Icon, Loader, Modal } from 'components';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useAction, useSelect, useModal } from 'hooks';
import ContainerTransactionItem from '../transaction-history/ContainerTransactionItem';
import 'react-big-calendar/lib/css/react-big-calendar.css';
const localizer = momentLocalizer(moment)

const Event = (data) => {
  
  return (
    <div className="flex flex-col items-center justify-center">
      <span className="text-sm font-bold">{get(data, 'title')}</span>
      <span className="text-xs">SLOT - {get(data, 'event.slot')}</span>
    </div>
  )
}

const ContainerAppointment = () => {
  const { params } = useRouteMatch()
  
  const history = useHistory()
  const getList = useAction('appointment.getList');
  const list = useSelect('appointment.list')
  const listing = useSelect('loading.isLoading', { type: 'appointment.getList' })

  const getSelected = useAction('payment.view')
  const selectedPayment = useSelect('payment.selected', { id: params.id })
  const showing = useSelect('loading.isLoading', { type: 'payment.view' })
  
const getApplication = useAction('application.show')
const applicationList = useSelect('application.list')
const cpcApplication = Object.values(applicationList)[0]

  const setAppointment = useAction('payment.setAppointment')
  const settingAppointment = useSelect('loading.isLoading', { type: 'payment.setAppointment' })
  const [selectedEvent, setSelectedEvent] = useState(null)

  const payNow = useAction('payment.payNow')
  const [paymentInfo, setPaymentInfo] = useState(null)
  const [isOpenPaymentModal, onOpenPaymentModal] = useModal()
  const paying = useSelect('loading.isLoading', { type: 'payment.payNow' })
  
  const events = Object.values(list).reduce((accumulator, current) => {
    
    const title = get(current, 'attributes.period') === 'AM' ? '8-12 AM' : '12-5 PM'

    return [
      ...accumulator,
      {
        id: get(current, 'id'),
        title,
        slot: get(current, 'attributes.available_slot'),
        
        start: moment(`${get(current, 'attributes.appointment_date')} 00:00:00`)._d,
        end: moment(`${get(current, 'attributes.appointment_date')} 12:00:00`)._d,
        fullInfo: current,
        isSelected: +get(current, 'id') === +get(selectedEvent, 'id')
      }
    ]
  }, [])

  useEffect(() => {
    getSelected(params.id)
    // eslint-disable-next-line
  }, [])
  
  useEffect(() => {
    getApplication(params.id)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    getList();
    // eslint-disable-next-line
  }, [])

  const handleBack = e => {
    e.preventDefault()
    history.push('/')
  }

  const handleSubmit = e => {
    e.preventDefault()
    setAppointment(params.id, {
      appointment_id: get(selectedEvent, 'id')
    }, () => {
      // history.push('/')
      if(!get(selectedPayment, 'attributes.status')){
        if(get(cpcApplication, 'attributes.service_type_name') === "TNVS") {
          return history.push('/')
        }
        return payNow(params.id, (response) => {
          onOpenPaymentModal()
          setPaymentInfo(response)
        })
      }

      return history.push('/')
    })
  }
  
  const onSelectEvent = e => {
    setSelectedEvent(e)
  }

  const eventPropGetter = data => {
    
    if(+get(data,'id') === +get(selectedEvent, 'id')){
      return {
        className: 'rbc-selected',
        stye: {}
      }  
    }
    return {
      className: '',
      stye: {}
    }
  }

  const onHandleClosePaymentModal = () => {
    history.push('/')
  }
  
  return (
    <>
      <Card className="transaction-history">
        <Card.Header>
          <div className="content space-x-2 flex items-center">
            <Button type="button" onClick={handleBack} className="!w-auto !px-2"><Icon.ChevronLeft /></Button>
            <b className="title font-medium">Select schedule to bring hard copies</b>
          </div>
        </Card.Header>  
        <Card.Body>
          {!showing && selectedPayment && 
            <div className="mb-5">
              <ContainerTransactionItem data={selectedPayment}/>
            </div>
          }
          {listing && <Loader.Table />}
          {!listing &&
          <Calendar
            selected={selectedEvent}
            selectable
            views={['month']}
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 'calc(100vh - 288px)' }}
            components={{
              event: Event
            }}
            eventPropGetter={eventPropGetter}
            onSelectEvent={onSelectEvent}
          />}
          <Button type="button" isLoading={settingAppointment} className="mt-2" onClick={handleSubmit}>Submit</Button>
      </Card.Body>         
    </Card>
    <Modal size="lg" isOpen={isOpenPaymentModal} onClose={onHandleClosePaymentModal}>
      <div className="p-0 xl:p-5 lg:p-2">
        {paying && 
          <div className="flex flex-col items-center justify-center">
            <span className="animate-pulse text-bold text-info">Witing for payment provider...</span>
            <Loader.Table />
          </div>
        }
        {!paying &&
        <iframe 
          title="Payment Gateway"
          className="w-full"
          style={{ height: 700 }}
          src={get(paymentInfo, `${params.id}.attributes.url`)} />}
      </div>
    </Modal>
  </>
  )
}

export default ContainerAppointment